<div #container class="email-delivery-hub-insights-container">
  <div
    class="email-delivery-hub-insights-pages"
    [style.transform]="'translateX(' + translateXValue() + '%)'"
    [style.width]="containerWidth()"
  >
    <!-- Page 1 -->
    <div id="page-one" class="email-delivery-hub-insights-page" [style.width]="pageWidth()">
      <div class="email-delivery-hub-insights-card email-delivery-hub-insights-card-total">
        <p dataSelector="metrics-total-label" class="email-delivery-hub-insights-card-title body-300">{{ total().label }}</p>
        <div class="email-delivery-hub-insights-card-numbers-container">
          <div class="email-delivery-hub-insights-card-numbers">
            @let totalValue = total().value;
            @let formattedTotalValue = totalValue | numberAbbr;
            <h3
              dataSelector="metrics-total-value"
              class="h2-500"
              [tooltip]="totalValue | number"
              [tooltipEnabled]="totalValue.toString() !== formattedTotalValue"
            >
              {{ totalValue | numberAbbr }}
            </h3>
          </div>

          @if (total().differFromLastMetric) {
            @let iconName = total().differFromLastMetric > 0 ? 'arrow-up' : 'arrow-down';

            <div
              class="email-delivery-hub-insights-card-highlight body-400"
              [class.email-delivery-hub-insights-card-highlight-down]="total().differFromLastMetric < 0"
              [class.email-delivery-hub-insights-card-highlight-up]="total().differFromLastMetric > 0"
              [tooltip]="comparisonDateRange()"
            >
              <anduin-icon [dataSelector]="'metrics-total-percentage-icon-' + iconName" [name]="iconName" />
              <p dataSelector="metrics-total-percentage-value">
                {{ getAbsoluteValue(total().differFromLastMetric) | percent }} vs. last period
              </p>
            </div>
          }
        </div>
      </div>

      @for (unit of units(); track unit.label) {
        <div class="email-delivery-hub-insights-card">
          <p dataSelector="metrics-card-label" class="email-delivery-hub-insights-card-title">{{ unit.label }}</p>
          <div class="email-delivery-hub-insights-card-numbers-container">
            <div class="email-delivery-hub-insights-card-numbers">
              @let unitValue = unit.value;
              @let formattedUnitValue = unitValue | numberAbbr;
              <h3
                dataSelector="metrics-card-value"
                [tooltip]="unitValue | number"
                [tooltipEnabled]="unitValue.toString() !== formattedUnitValue"
              >
                {{ unitValue | numberAbbr }}
              </h3>
            </div>
            @if (unit.differFromLastMetric) {
              <div class="email-delivery-hub-insights-card-highlight" [ngClass]="unit.highlightClass" [tooltip]="comparisonDateRange()">
                <anduin-icon [dataSelector]="'metrics-card-percentage-icon-' + unit.icon" [name]="unit.icon" />
                <p dataSelector="metrics-card-percentage-value">
                  {{ getAbsoluteValue(unit.differFromLastMetric) | percent: '1.0-0' }} vs. last period
                </p>
              </div>
            }
          </div>
        </div>
      }
    </div>
    @if (hasMultiplePages()) {
      @for (pageItems of pages(); track pageItems) {
        <div class="email-delivery-hub-insights-page" [style.width]="pageWidth()">
          @for (unit of pageItems; track unit.label) {
            <div class="email-delivery-hub-insights-card">
              <p class="email-delivery-hub-insights-card-title">{{ unit.label }}</p>
              <div class="email-delivery-hub-insights-card-numbers-container">
                <div class="email-delivery-hub-insights-card-numbers">
                  @let unitValue = unit.value;
                  @let formattedUnitValue = unitValue | numberAbbr;
                  <h3
                    [tooltip]="unitValue | number"
                    [tooltipEnabled]="unitValue.toString() !== formattedUnitValue"
                  >
                    {{ unitValue | numberAbbr }}
                  </h3>
                </div>
                @if (unit.differFromLastMetric) {
                  <div class="email-delivery-hub-insights-card-highlight" [ngClass]="unit.highlightClass" [tooltip]="comparisonDateRange()">
                    <anduin-icon [name]="unit.icon" />
                    <p>{{ getAbsoluteValue(unit.differFromLastMetric) | percent: '1.0-0' }} vs. last period</p>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    }
  </div>

  <!-- Navigation Button -->
  @if (hasMultiplePages()) {
    <button
      class="email-delivery-hub-insights-nav-button"
      [disabled]="isTransitioning()"
      (click)="reachedThePageLimit() ? previousPage() : nextPage()"
    >
      <anduin-icon [name]="reachedThePageLimit() ? 'chevron-left' : 'chevron-right'" />
    </button>
  }
</div>
